import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { NewPresentationSearchSchema } from '../features/presentations/guided-create/guided-create-model';
import { NewPresentationPage } from '../features/presentations/new-presentation-page';
export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/presentations/new')({
  component: RouteComponent,
  validateSearch: zodValidator(NewPresentationSearchSchema),
});
function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <NewPresentationPage
      companySlug={companySlug}
      onSearchChange={(next, replace) => void navigate({ replace, search: next })}
      projectId={projectId}
      search={search}
    />
  );
}
